import { render, staticRenderFns } from "./CourseVideoPlaceholderGuest.vue?vue&type=template&id=03681c03&scoped=true"
import script from "./CourseVideoPlaceholderGuest.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlaceholderGuest.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoPlaceholderGuest.vue?vue&type=style&index=0&id=03681c03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03681c03",
  null
  
)

export default component.exports